import moment from "moment";
import { GeneralAssetType } from "../validations";
import { DataAssetType } from "../../types";

export const defaultValueGeneralAsset = (value: Partial<DataAssetType> = {}): GeneralAssetType => ({
    transaction_date: value.transaction_date || moment().format("YYYY-MM-DD"),
    mr_group_id: value.mr_group_id || "",
    mr_brand_id: value.mr_brand_id || "",
    asset_code: value.asset_code || "",
    asset_foto: value.asset_foto || [],
    asset_name: value.asset_name || "",
    mr_document_id: value.mr_document_id || "",
    serial_document: value.serial_document || "",
    acquisition_cost: value.acquisition_cost || 0,
    acquisition_date: value.acquisition_date || moment().format("YYYY-MM-DD"),
    depreciation_duration: value.depreciation_duration || 0,
    depreciation_expired: value.depreciation_expired || moment().format("YYYY-MM-DD"),
    vendor_id: value.vendor_id || "",
});
